//记得在 src\components\lang\zhLoad.js 里面添加对象
const plant = {
  plantCode:'基地编码',
  plantName: '基地名称',
  createTime: '创建时间',
  msg: {
  }
};
export default plant



// WEBPACK FOOTER //
// ./src/page/md/plant/lang/plant.en.js